import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";

@Component({
  selector: "app-upload-warning",
  templateUrl: "./upload-warning.component.html",
  styleUrls: ["./upload-warning.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadWarningComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
